import baseMessage from './baseMessage'

export const ES_CW = {
  message: {
    ...baseMessage,
    label: {
      dni: 'Registration Number',
      userHint: 'Se puede buscar por Nombres, Apellidos, Registration Number'
    }
  }
}
